// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--33VRo";
export var middling = "styles-module--middling--YTDo9";
export var negative = "styles-module--negative--2j3vr";
export var positive = "styles-module--positive--2ybA8";
export var regulatorsRatingContainer = "styles-module--regulatorsRatingContainer--A1o5v";
export var unrated = "styles-module--unrated--1JLoK";